// The length of one work day of an installer
export const HOURS_PER_WORK_DAY = 8;

// Work days in a week, and in a month on average
export const WORK_DAYS_PER_WEEK = 5;
export const WORK_DAYS_PER_MONTH = 21;

export const getWorkWeeks = (workDays: number): number =>
  workDays > 0 ? workDays / WORK_DAYS_PER_WEEK : 0;

export const getWorkMonths = (workDays: number): number =>
  workDays > 0 ? workDays / WORK_DAYS_PER_MONTH : 0;

export type InstallationTimeField = 'days' | 'weeks' | 'months';

/** The work days of a time given in work days, weeks or months */
export const toWorkDays = (
  field: InstallationTimeField,
  value: number
): number => {
  if (!(value > 0)) {
    return 0;
  }

  if (field === 'weeks') {
    return value * WORK_DAYS_PER_WEEK;
  }

  if (field === 'months') {
    return value * WORK_DAYS_PER_MONTH;
  }

  return value;
};

/** Work days of the installation: the total hours shared by the installers, 8 h a day */
export const getWorkDays = (totalHours: number, installers: number): number =>
  totalHours > 0 && installers > 0
    ? totalHours / HOURS_PER_WORK_DAY / installers
    : 0;

/** Installers needed to do the total hours in the given work days, 8 h a day */
export const getInstallersForWorkDays = (
  totalHours: number,
  workDays: number
): number =>
  totalHours > 0 && workDays > 0
    ? totalHours / HOURS_PER_WORK_DAY / workDays
    : 0;
